var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.58786 4.86941V6.22233H3.23492C2.81431 6.22233 2.47022 6.52541 2.47022 6.89881V15.8174C2.71031 15.7416 2.96574 15.6929 3.23492 15.6929H18.529C18.7982 15.6929 19.0536 15.7416 19.2937 15.8174V6.89882C19.2937 6.52542 18.9496 6.22236 18.529 6.22236H13.1761V4.86941H18.529C19.7939 4.86941 20.8231 5.77993 20.8231 6.89881V21.7812C20.8231 22.9001 19.7938 23.8106 18.529 23.8106H3.23492C1.97008 23.8106 0.940796 22.9 0.940796 21.7812V6.89881C0.940796 5.77993 1.9701 4.86941 3.23492 4.86941H8.58786ZM18.529 17.0459H3.23492C2.81431 17.0459 2.47022 17.3489 2.47022 17.7223V21.7812C2.47022 22.1546 2.81431 22.4576 3.23492 22.4576H18.529C18.9496 22.4576 19.2937 22.1546 19.2937 21.7812V17.7223C19.2937 17.3489 18.9496 17.0459 18.529 17.0459V17.0459ZM11.6471 0.810303V11.3538L14.9813 8.40301L16.0626 9.35955L10.8824 13.9433L5.70079 9.35955L6.78209 8.40301L10.1177 11.3538V0.810315H11.6471L11.6471 0.810303ZM5.52904 18.3988C4.6848 18.3988 3.99961 19.0063 3.99961 19.7517C3.99961 20.4972 4.6848 21.1047 5.52904 21.1047C6.37327 21.1047 7.05843 20.4972 7.05843 19.7517C7.05843 19.0063 6.37327 18.3988 5.52904 18.3988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAssessment);
export default __webpack_public_path__ + "static/media/save-assessment.29e854cc8340ac31598c39fb3e7247be.svg";
export { ForwardRef as ReactComponent };